import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import type { RegisterSearch } from './register'
import { rootRoute } from './root'

const SlotRegister = lazyRouteComponent(() => import('../pages/slot-register'))

export const slotRegisterRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/slot-register',
  component: SlotRegister,
  validateSearch: (search: Record<string, unknown>): RegisterSearch => {
    return search
  },
})
